// extracted by mini-css-extract-plugin
module.exports = {"mainBlockTitle":"_1vRCepGP","candidateContent":"_3LpuxbgB","statusContent":"_1lwTh_q7","dateContent":"_3ZxPM2rV","companyHeader":"_37bZz1lL","otherHeader":"_2ztcECoe","blockTitle":"_3BOLll0m","firstBlock":"_2Cn6h6YW"};
    if(module.hot) {
      // 1746735877882
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  